import React, { Component } from "react";
import { observer } from "mobx-react";
import { partnerIcon, commaString } from "utils/Utils";
import { fn_product_detail_pop, fn_productSalesDetail } from "function/FnBodySales";

@observer
class SalesProductItemView extends Component {
  render() {
    const { rootStore, sales } = this.props;
    let option = [];
    let img_icon = [];
    let txt = "";
    for (let i = 0; i < sales.productTypeList.length; i++) {
      if (sales.productTypeList[i] == "menu") {
        txt = "메뉴";
      } else {
        txt = "옵션";
      }
      if (i == 1) {
        option.push("," + txt);
      } else {
        option.push(txt);
      }
    }


    if (sales.orderChannels.length != 0) {
      if (sales.orderChannels.length >= 2) {
        for (let i = 0; i < 2; i++) {
          let img = partnerIcon(sales.orderChannels[i]);
          img_icon.push(
            <div key={i} className="thumb">
              <img src={img} width="30" height="30" alt={"logo"} />
              <span className="frame"></span>
            </div>
          );
        }
      } else {
        let img = partnerIcon(sales.orderChannels[0]);
        img_icon.push(
          <div key="0" className="thumb">
            <img src={img} width="30" height="30" alt={"logo"} />
            <span className="frame"></span>
          </div>
        );
        img_icon.push(<div key="1" className="thumb"></div>);
      }
    }

    return (
      <tr
        onClick={event => {
          event.preventDefault();
          fn_productSalesDetail(rootStore, sales.productName);
          fn_product_detail_pop(rootStore, true);
        }}
      >
        <td className="row_no">{sales.rowNo}</td>
        <td className="name">
          <div className="txt_overflow">{sales.productName}</div>
        </td>
        <td className="product_type">{option}</td>
        <td className="pay sales">{sales.saleCount}개</td>
        <td className="sales_cnt_share">{sales.saleCountShare}%</td>
        <td className="pay">{commaString(sales.saleAmount)}원</td>
        <td className="sales_amount_share">{sales.saleAmountShare}%</td>
        <td className="cahnnel">{img_icon}</td>
      </tr>
    );
  }
}

export default SalesProductItemView;
